module.exports = __webpack_public_path__ + "static/media/icon_right_row.07129f00.svg";